import { render, staticRenderFns } from "./Fights.vue?vue&type=template&id=71df3136&scoped=true&lang=pug&"
import script from "./Fights.vue?vue&type=script&lang=js&"
export * from "./Fights.vue?vue&type=script&lang=js&"
import style0 from "./Fights.vue?vue&type=style&index=0&id=71df3136&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71df3136",
  null
  
)

export default component.exports